import { c as _c } from "react-compiler-runtime";
import { createContext, useContext, useReducer, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const initialSpyData = {
  topicsWithSenders: new Set(),
  topicsWithHandlers: new Set()
};
function spyReducer(state, action) {
  switch (action.type) {
    case 'REGISTER_SENDER':
      if (state.topicsWithSenders.has(action.topic)) {
        return state;
      }
      return Object.assign({}, state, {
        topicsWithSenders: new Set([...state.topicsWithSenders, action.topic])
      });
    case 'REGISTER_HANDLER':
      if (state.topicsWithHandlers.has(action.topic)) {
        return state;
      }
      return Object.assign({}, state, {
        topicsWithHandlers: new Set([...state.topicsWithHandlers, action.topic])
      });
    case 'RESET':
      return initialSpyData;
    default:
      return state;
  }
}
const MessageBusSpyContext = /*#__PURE__*/createContext(null);
export const MessageBusSpy = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [spyData, dispatch] = useReducer(spyReducer, initialSpyData);
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = topic => dispatch({
      type: "REGISTER_SENDER",
      topic
    });
    t2 = topic_0 => dispatch({
      type: "REGISTER_HANDLER",
      topic: topic_0
    });
    t3 = () => dispatch({
      type: "RESET"
    });
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== spyData) {
    t4 = {
      spyData,
      registerSender: t1,
      registerHandler: t2,
      reset: t3
    };
    $[3] = spyData;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const contextValue = t4;
  let t5;
  if ($[5] !== children || $[6] !== contextValue) {
    t5 = /*#__PURE__*/_jsx(MessageBusSpyContext.Provider, {
      value: contextValue,
      children: children
    });
    $[5] = children;
    $[6] = contextValue;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const useMessageBusSpyContext = () => {
  return useContext(MessageBusSpyContext);
};
export const useMessageBusSpyData = () => {
  const context = useContext(MessageBusSpyContext);
  if (!context) {
    throw new Error("useMessageBusSpyData must be used within a MessageBusSpy component");
  }
  return context.spyData;
};
export const useRegisterSender = () => {
  const context = useMessageBusSpyContext();
  return context === null || context === void 0 ? void 0 : context.registerSender;
};
export const useRegisterHandler = () => {
  const context = useMessageBusSpyContext();
  return context === null || context === void 0 ? void 0 : context.registerHandler;
};
export const useResetMessageBusSpy = () => {
  const context = useMessageBusSpyContext();
  return context === null || context === void 0 ? void 0 : context.reset;
};